<div class="center">
    <div>
    <img class="lightspeed-logo" src="../../../../../../assets//pos/lightspeed-thin.png">
    <div class="waiting">{{'onboarding.messages.finishing_off' | translate}}</div>
    </div>
  </div>